export function emptyIfValidator(value: any, params: any[] | Record<string, any>) {
  const emptyIf = (params as { [key: string]: boolean }).emptyIf
  const errorMessage = (params as { [key: string]: string }).errorMessage
  if (emptyIf === true) {
    return false
  } else {
    return true
  }
}
